import { ResourceTypeEnum } from "../../../Enums/ResourceTypeEnum";
import {
  isResourceResponseDTO,
  ResourceResponseApi,
} from "../Resource/Resource";
import { isResourceIdResponseDTO } from "../Resource/ResourceId";
import {
  isTaskWithContentResponseDTO,
  isTaskWithNameAndCostAndContentResponseDTO,
  TaskResponseApi,
} from "../Task/Task";
import { isTaskIdResponseDTO } from "../Task/TaskId";
import { isModuleResourceIdResponseDTO } from "./ModuleResource/ModuleResourceId";

export interface ModuleResourcePropApi {
  moduleResourceId?: string;
  order?: number;
  required?: boolean;
  resourceId?: string;
  taskId?: string;
}

export interface ModuleResourceResponseApi extends ModuleResourcePropApi {
  moduleResourceId: string;
  required: boolean;
  resource?: ResourceResponseApi;
  task?: TaskResponseApi;
}

export let isModuleResourceResponseDTO = (
  variable: unknown
): variable is ModuleResourceResponseApi => {
  return (
    isModuleResourceIdResponseDTO(variable) &&
    "required" in variable &&
    typeof variable.required === "boolean" &&
    // One - resource or task - must be
    (("resource" in variable &&
      isResourceResponseDTO(variable.resource) &&
      isResourceIdResponseDTO(variable)) ||
      ("task" in variable &&
        isTaskWithContentResponseDTO(variable.task) &&
        isTaskIdResponseDTO(variable)))
  );
};

export let isModuleResourceWithSomeTaskInfoResponseDTO = (
  variable: unknown
): variable is ModuleResourceResponseApi => {
  return (
    isModuleResourceIdResponseDTO(variable) &&
    "required" in variable &&
    typeof variable.required === "boolean" &&
    // One - resource or task - must be
    "resource" in variable &&
    ((isResourceResponseDTO(variable.resource) &&
      isResourceIdResponseDTO(variable)) ||
      ("task" in variable &&
        isTaskWithNameAndCostAndContentResponseDTO(variable.task) &&
        isTaskIdResponseDTO(variable)))
  );
};

export interface ModuleResourceWithOrderResponseApi
  extends ModuleResourceResponseApi {
  order: number;
}

export let isModuleResourceWithOrderResponseDTO = (
  variable: ModuleResourceResponseApi
): variable is ModuleResourceWithOrderResponseApi => {
  return "order" in variable && typeof variable.order === "number";
};

export interface ModuleResourceWithScenarioOrMaterialResponseApi
  extends ModuleResourceResponseApi {
  resource: ResourceResponseApi;
  resourceId: string;
}

export let isModuleResourceWithScenarioOrMaterialResponseDTO = (
  variable: ModuleResourceResponseApi
): variable is ModuleResourceWithScenarioOrMaterialResponseApi => {
  return (
    "resource" in variable &&
    isResourceResponseDTO(variable.resource) &&
    (variable.resource.resourceTypeId === ResourceTypeEnum.Scenario ||
      variable.resource.resourceTypeId === ResourceTypeEnum.MaterialForStudent)
  );
};
